module.exports = __webpack_public_path__ + "img/SURVEY_MEMORYLOSS_SM.dc834ea7.png";